import { Link, useLocation } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";

export default function NotFound() {
  const location = useLocation();

  return (
    <>
      <Navbar />
      <main className="pt-16 min-h-screen flex items-center justify-center px-4">
        <div className="text-center">
          <div className="text-8xl md:text-9xl font-black text-background-200 select-none mb-4 font-heading">
            404
          </div>
          <h1 className="text-xl md:text-2xl font-bold text-foreground-950 font-heading mb-2">
            页面未找到
          </h1>
          <p className="text-sm text-foreground-600 mb-2 font-mono">{location.pathname}</p>
          <p className="text-sm text-foreground-600 mb-8">抱歉，您访问的页面不存在或已被移除</p>
          <Link
            to="/"
            className="inline-flex items-center gap-2 px-6 py-2.5 rounded-lg bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            <i className="ri-home-4-line"></i>
            返回首页
          </Link>
        </div>
      </main>
      <Footer />
    </>
  );
}